export default "__VITE_ASSET__85df7b32__"